<template>
	<div class="card text-bg-white border-2 border-dark" :class="{ 'placeholder-glow': placeholder }">
		<div class="card-body pb-2">
			<template v-if="placeholder">
				<div class="lh-sm placeholder col-12"></div>
				<div class="lh-sm placeholder col-12"></div>
			</template>
			<div class="vstack gap-2" v-else>
				<p class="lh-sm">Te invitaron a unirte a la empresa <b>{{ invitation.company.name }}</b> con los siguientes roles:</p>
				<div class="hstack gap-2">
					<span v-for="(role, index) in invitation.roles" v-bind:key="index" class="badge rounded-pill bg-dark text-xs">{{ $env.MODEL.User.roles[role].title }}</span>
				</div>
			</div>
		</div>
		<div class="card-footer hstack gap-3 border-0 justify-content-end">
			<template v-if="placeholder">
				<div class="btn rounded-pill placeholder col-3"></div>
				<div class="btn rounded-pill placeholder col-3"></div>
			</template>
			<template v-else>
				<button type="button" class="btn btn-danger rounded-pill" :disabled="submitting" @click="reject">Rechazar</button>
				<button type="button" class="btn btn-success rounded-pill" :disabled="submitting" @click="accept">Aceptar</button>
			</template>
		</div>
	</div>
</template>

<script>
	import router from '@/router';
	import store from '@/store';
	import composableForm from '@/composables/form';
	import InvitationRepository from '@/repositories/modules/Invitation';

	export default {
		props: {
			invitation: Object,
			subtitle: {
				type: String,
				default: null
			},
			placeholder: {
				type: Boolean,
				default: false
			}
		},
		setup(props) {
			const { submitting, catchError } = composableForm();

			const accept = async () => {
				submitting.value = true;

				await InvitationRepository.accept(props.invitation.uuid).then(async () => {
					await store.dispatch('auth/me').then(() => {
						router.push({ name: 'home' });
					}).catch((e) => catchError(e, true));
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const reject = async () => {
				submitting.value = true;

				await InvitationRepository.reject(props.invitation.uuid).then(() => {
					router.push({ name: 'company.select' });
				}).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			return { submitting, accept, reject };
		}
	}
</script>